<template>
  <div>
    <wd-status-tip type="collect" tip="暂无关注的物品" />
    <div class="footer">
      <van-tabbar v-model="active">
        <van-tabbar-item icon="home-o" to="/">首页</van-tabbar-item>
        <van-tabbar-item icon="like-o" to="/Pay">关注</van-tabbar-item>
        <van-tabbar-item icon="comment-o " to="/Hall">大厅</van-tabbar-item>
        <van-tabbar-item icon="manager-o" to="MyLogin">我的</van-tabbar-item>
      </van-tabbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pay",
  data() {
    return {
      active: 1,
    }
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pay.vue